<template>
  <div class="home">
    <img src="../../../images/logo.png" class="logo"/>
  </div>
</template>

<script>
export default {
  name: 'Home_home'
}
</script>
<style scoped>
.home{
    height: 100%;
    width: 100%;
    display:flex;
    justify-content:center;
}
.logo{
    height: 10rem;
    width: 10rem;
}
</style>>
